// Unpublished Work © 2026 Deere & Company.

import * as actions from '../../action-list';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';
import {FacetOptions} from '../../state/struct/digital-user-search/facets/facet-options';

const updateStates = (state, action) => FacetOptions.update(state, {
    states: {
        $set: action.states
    }
});

const updateIsLoadingStates = (state, action) => FacetOptions.update(state, {
    isLoadingStates: {
        $set: action.isLoadingStates
    }
});

const resetFacetOptions = () => new FacetOptions({});

export const facetOptions = (state = new DigitalUserSearch({}).facetOptions, action = {}) => {
    const actionHandlers = {
        [actions.SET_DIGITAL_USER_SEARCH_STATES]: updateStates,
        [actions.SET_DIGITAL_USER_SEARCH_STATES_LOADING]: updateIsLoadingStates,
        [actions.RESET_DIGITAL_USER_SEARCH]: resetFacetOptions
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
